export const API_URL = "https://api.otim.com";
